import translate from "@deosite/helpers/langLibrary";

import Container from "@commerce-ui/core2/Container";
import Box from "@commerce-ui/core2/Box";
import Grid from "@commerce-ui/core2/Grid";

import PageContainer from "../containers/UI/PageContainer";
import ProductBox from "../components/ProductBox";

import { useRecentlyViewedProducts } from "@deosite/api/hooks/common/useRecentlyViewedProducts";

const Custom404 = props => {
  const translations = {
    seoDescription: translate("Default seo description"),
    seoTitle: translate("Default seo title"),
    possibleFailure: translate(
      "Possible service failure. Please wait a moment and try again."
    ),
    pageNotFound: translate("Page not found"),
    goToHomePage: translate("Go to home page"),
    recentlyViewed: translate("Check recently viewed")
  };

  const recentlyViewedProducts = useRecentlyViewedProducts();

  return (
    <PageContainer
      metaTagsData={{
        description: translations.seoDescription,
        title: translations.seoTitle
      }}
      recentlyViewedActive={false}
      footerContent={props.footerContent}
    >
      <Container>
        <Box
          sx={{
            display: "flex",
            mt: "s10",
            color: "main",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            minHeight: "50vh"
          }}
        >
          <Box as={"p"} sx={{ font: "xxl" }}>
            {translations.pageNotFound}
          </Box>
          {recentlyViewedProducts?.length > 0 && (
            <Box sx={{ mt: "s8" }}>
              <Box
                as={"p"}
                sx={{
                  color: "main",
                  font: "base",
                  my: "s8",
                  textAlign: "center"
                }}
              >
                {translations.recentlyViewed}
              </Box>
              <Grid
                cols={[
                  recentlyViewedProducts?.length / 2,
                  null,
                  recentlyViewedProducts?.length,
                  null
                ]}
                sx={{ gridRowGap: "s11" }}
              >
                {recentlyViewedProducts.map((product, index) => (
                  <ProductBox key={index} product={product} />
                ))}
              </Grid>
            </Box>
          )}
        </Box>
      </Container>
    </PageContainer>
  );
};

export default Custom404;
